import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { verstuurProductieUitnodigingenBulk } from '../api/api';
import { fmtId } from '../util/format';

export default function ProductieUitnodigingen() {
  const navigate = useNavigate();
  const [jaar, setJaar] = useState(new Date().getFullYear() - 1);
  const [bevestigOpen, setBevestigOpen] = useState(false);
  const [bezig, setBezig] = useState(false);
  const [resultaat, setResultaat] = useState(null);
  const [error, setError] = useState(null);

  const verstuur = async () => {
    setBezig(true);
    setError(null);
    setResultaat(null);
    setBevestigOpen(false);
    try {
      const res = await verstuurProductieUitnodigingenBulk(jaar);
      setResultaat(res.data);
    } catch (e) {
      setError(e?.response?.data?.detail || e.message);
    } finally {
      setBezig(false);
    }
  };

  return (
    <div className="main-inner">
      <div className="page-header">
        <div>
          <button className="btn btn-ghost" onClick={() => navigate('/beheertools')} style={{ marginBottom: 12 }}>
            ← Terug naar beheertools
          </button>
          <h1 className="page-title">Productieopgaven versturen</h1>
          <p className="page-subtitle">
            Stuur in één keer aan alle inrichtingen die voor het opgavejaar nog niet compleet zijn een uitnodiging om hun kwartaalcijfers door te geven.
          </p>
        </div>
      </div>

      <div className="card" style={{ maxWidth: 640, padding: 24 }}>
        <p style={{ marginTop: 0, color: 'var(--text-muted)', fontSize: 14, lineHeight: 1.6 }}>
          Per inrichting wordt gekeken welke kwartalen van het opgavejaar nog ontbreken én van toepassing zijn (de inrichting moet in dat kwartaal hebben bestaan). Inrichtingen waarvan alle cijfers al binnen zijn, of die geen e-mailadres hebben, worden overgeslagen. Houders met meerdere inrichtingen krijgen per inrichting een aparte e-mail.
        </p>

        <div className="field" style={{ marginTop: 16 }}>
          <label className="field-label">Opgavejaar</label>
          <input
            type="number"
            value={jaar}
            min="2000"
            max={new Date().getFullYear()}
            onChange={(e) => setJaar(parseInt(e.target.value, 10) || jaar)}
            style={{ width: 120 }}
          />
        </div>

        <div style={{ marginTop: 20 }}>
          <button className="btn btn-primary" onClick={() => setBevestigOpen(true)} disabled={bezig}>
            {bezig ? 'Bezig met versturen…' : 'Uitnodigingen versturen'}
          </button>
        </div>

        {error && (
          <div className="melding fout" style={{ marginTop: 16, padding: '10px 14px', borderRadius: 10, background: 'var(--danger-soft, #fff1f2)', color: '#dc2626', fontSize: 14 }}>
            {error}
          </div>
        )}
      </div>

      {bevestigOpen && (
        <div className="modal-overlay" onClick={() => setBevestigOpen(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 440 }}>
            <h2 style={{ marginTop: 0, fontSize: 18 }}>Uitnodigingen versturen?</h2>
            <p style={{ color: 'var(--text-soft)', fontSize: 14, lineHeight: 1.6 }}>
              Er worden e-mails verstuurd naar alle inrichtinghouders met een e-mailadres die voor <strong>{jaar}</strong> nog niet compleet zijn. Dit kan niet ongedaan worden gemaakt.
            </p>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16 }}>
              <button className="btn btn-ghost" onClick={() => setBevestigOpen(false)}>Annuleren</button>
              <button className="btn btn-primary" onClick={verstuur}>Ja, versturen</button>
            </div>
          </div>
        </div>
      )}

      {resultaat && (
        <div className="card" style={{ maxWidth: 640, padding: 24, marginTop: 20 }}>
          <h3 style={{ marginTop: 0, fontSize: 16 }}>Resultaat voor {resultaat.jaar}</h3>
          <ul style={{ listStyle: 'none', padding: 0, margin: '12px 0 0', fontSize: 14 }}>
            <li style={{ padding: '6px 0', borderBottom: '1px solid var(--border)' }}>
              <strong>{resultaat.aantal_verzonden}</strong> verzonden
            </li>
            <li style={{ padding: '6px 0', borderBottom: '1px solid var(--border)' }}>
              <strong>{resultaat.aantal_overgeslagen_compleet}</strong> overgeslagen (al compleet)
            </li>
            <li style={{ padding: '6px 0', borderBottom: '1px solid var(--border)' }}>
              <strong>{resultaat.aantal_zonder_email}</strong> overgeslagen (geen e-mailadres)
            </li>
            {resultaat.aantal_mislukt > 0 && (
              <li style={{ padding: '6px 0', color: '#dc2626' }}>
                <strong>{resultaat.aantal_mislukt}</strong> mislukt
              </li>
            )}
          </ul>

          {resultaat.zonder_email?.length > 0 && (
            <details style={{ marginTop: 12 }}>
              <summary style={{ cursor: 'pointer', fontSize: 13, color: 'var(--text-muted)' }}>
                Inrichtingen zonder e-mailadres ({resultaat.zonder_email.length})
              </summary>
              <p style={{ fontSize: 13, color: 'var(--text-soft)', margin: '8px 0 0', lineHeight: 1.7 }}>
                {resultaat.zonder_email.map(fmtId).join(', ')}
              </p>
            </details>
          )}

          {resultaat.mislukt?.length > 0 && (
            <details style={{ marginTop: 8 }}>
              <summary style={{ cursor: 'pointer', fontSize: 13, color: '#dc2626' }}>
                Mislukte verzendingen ({resultaat.mislukt.length})
              </summary>
              <ul style={{ fontSize: 13, color: 'var(--text-soft)', margin: '8px 0 0' }}>
                {resultaat.mislukt.map((m) => (
                  <li key={m.inrichting_id}>{fmtId(m.inrichting_id)}: {m.fout}</li>
                ))}
              </ul>
            </details>
          )}
        </div>
      )}
    </div>
  );
}
